
import { FileDTO } from "bbsf-controls"

export class LicenseModel
{
    LicenseFile:FileDTO
    appendExisting :boolean=false;
}
     